module.exports = __webpack_public_path__ + "static/img/3.c8400e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/3.png
// module id = becZ
// module chunks = 0